import React, { useEffect } from "react";
import { Doughnut } from "react-chartjs-2";
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
} from "chart.js";
import { useDispatch, useSelector } from "react-redux";
import { getAdvisorMertrixAction } from "../../actions/advisor";

ChartJS.register(ArcElement, Tooltip, Legend);

const COLORS = {
    purple: "#3859ffcc",
    blue: "#20a0f3cc",
    orange: "#f97026cc",
    subtleBlue: "#2978b5cc",
};

const gradients = {
    orange: "linear-gradient(317deg, rgba(254, 205, 79, 0.80) 1.72%, rgba(249, 112, 38, 0.80) 80.35%)",
    blue: "linear-gradient(119deg, rgba(115, 105, 222, 0.80) 11.96%, rgba(32, 160, 243, 0.80) 100%)",
    aqua: "linear-gradient(121deg, rgba(170, 247, 251, 0.80) 0%, rgba(41, 120, 181, 0.80) 76.02%)",
    violet: "linear-gradient(299deg, rgba(151, 165, 235, 0.80) 16.63%, rgba(56, 89, 255, 0.80) 85.85%)",
};

export default function MetricsDashboard() {

    const dispatch = useDispatch()
    const { metrixAdvisor } = useSelector(state => state.advisor)

    useEffect(() => {
        dispatch(getAdvisorMertrixAction())
    }, [dispatch])

    const chartData = {
        labels: ["Leads Submitted", "Quotes Sent", "Sandboxes Created", "Deals Closed"],
        datasets: [
            {
                data: [
                    metrixAdvisor?.inviteCount,
                    metrixAdvisor?.paymentLinkCount,
                    metrixAdvisor?.businessCreatedCount,
                    metrixAdvisor?.businessVerifiedCount,
                ],
                backgroundColor: [COLORS.blue, COLORS.orange, COLORS.subtleBlue, COLORS.purple],
                borderWidth: 0,
                cutout: "65%",
            },
            {
                data: [100, 100, 100, 100],
                backgroundColor: [
                    "rgba(75, 184, 255, 0.15)",
                    "rgba(255, 133, 77, 0.15)",
                    "rgba(120, 170, 255, 0.12)",
                    "rgba(91, 108, 255, 0.12)",
                ],
                borderWidth: 0,
                cutout: "80%",
                weight: 0.6,
            },
        ],
    };

    const chartOptions = {
        plugins: {
            legend: { display: false },
        },
        maintainAspectRatio: false,
    };

    return (
        <div className="container-fluid py-3">
            <div className="row">
                {/* Left card */}
                <div className="col-md-4 mb-3">
                    <div className="card h-100 shadow-sm">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <h6 className="md-title">Metrix</h6>
                            </div>

                            {/* Legend */}
                            <div className="row text-muted small mb-2">
                                <div className="col-6">
                                    <LegendDot color={COLORS.blue} label="Leads Submitted" />
                                </div>
                                <div className="col-6">
                                    <LegendDot color={COLORS.orange} label="Quotes Sent" />
                                </div>
                                <div className="col-6">
                                    <LegendDot color={COLORS.subtleBlue} label="Sandboxes Created" />
                                </div>
                                <div className="col-6">
                                    <LegendDot color={COLORS.purple} label="Deals Closed" />
                                </div>
                            </div>

                            {/* Chart */}
                            <div style={{ height: "200px" }}>
                                <Doughnut data={chartData} options={chartOptions} />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right tiles */}
                <div className="col-md-8">
                    <div className="row g-3">
                        <div className="col-md-6">
                            <MetricTile
                                title="Leads Submitted"
                                value={metrixAdvisor?.inviteCount}
                                gradient={gradients.blue}
                                icon='/assets/img/leads-submitted.svg'
                            />
                        </div>
                        <div className="col-md-6">
                            <MetricTile
                                title="Quotes Sent"
                                value={metrixAdvisor?.paymentLinkCount}
                                gradient={gradients.orange}
                                icon='/assets/img/quotes-sent.svg'

                            />
                        </div>
                        <div className="col-md-6">
                            <MetricTile
                                title="Sandboxes Created"
                                value={metrixAdvisor?.businessCreatedCount}
                                gradient={gradients.aqua}
                                icon='/assets/img/sandbox-created.svg'

                            />
                        </div>
                        <div className="col-md-6">
                            <MetricTile
                                title="Deals Closed"
                                value={metrixAdvisor?.businessVerifiedCount}
                                gradient={gradients.violet}
                                icon='/assets/img/deals-close.svg'

                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function LegendDot({ color, label }) {
    return (
        <div className="d-flex align-items-center mb-2">
            <span
                className="md-dot"
                style={{
                    backgroundColor: color,
                }}
            ></span>
            <p className="md-legend-text">{label}</p>
        </div>
    );
}

function MetricTile({ title, value, gradient, icon }) {
    return (
        <div
            className="card text-white h-100"
            style={{
                background: gradient,
                borderRadius: "16px",
                position: "relative",
                overflow: "hidden",
            }}
        >
            <div className="card-body d-flex flex-column justify-content-between">
                <h6 className="md-tile-title">{title}</h6>
                <div className="md-tile-row">
                    <h2 className="md-tile-value">{value}</h2>
                    <div className="md-tile-icon">
                        <img src={icon} />
                    </div>
                </div>
            </div>
        </div>
    );
}
